<script lang="ts">
    import BaseSkeleton from "@components/skeletons/BaseSkeleton.svelte";
    import StackedSkeleton from "@components/skeletons/StackedSkeleton.svelte";

    import ReviewsListHeaderFrame from "./ReviewsListHeaderFrame.svelte";
</script>

<ReviewsListHeaderFrame on:addQuestion on:addReview>
    <svelte:fragment slot="avg">
        <BaseSkeleton width="4.1875em" height="2.1875em" />
    </svelte:fragment>

    <svelte:fragment slot="rating">
        <BaseSkeleton width="5em" height="1.25em" />
    </svelte:fragment>

    <svelte:fragment slot="count">
        <BaseSkeleton width="6.9375em" height="1.1875em" />
    </svelte:fragment>

    <svelte:fragment slot="progress-bars">
        <StackedSkeleton
            count={5}
            width="257px"
            height="0.75em"
            gap="0.625em"
        />
    </svelte:fragment>
</ReviewsListHeaderFrame>
